<template>
  <div class="user_management">
    <!--  用户管理  -->
    <div class="search_data">
      <div class="item_title">Status:</div>
      <div class="item_select">
        <el-select
          clearable
          v-model="selectValue"
          placeholder="All"
          @change="getUserList"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="item_keyword">
        <el-input
          v-model="inputValue"
          placeholder="Please Enter Name Keywords"
        ></el-input>
      </div>
      <div class="item_submit" @click="searchData">Search</div>
    </div>
    <!-- 数据表格 -->
    <div class="table">
      <TableTem
        size="mini"
        :isSelection="false"
        :isIndex="true"
        :isPagination="true"
        :isHandle="true"
        :tableData="tableData"
        :tableCols="tableCols"
        :pagination="pagination"
        @select="select"
        @passRowData="passRowData"
        @switchVal2="switchVal2"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></TableTem>
    </div>
    <!-- 添加关联品牌 -->
    <AddNewDialog
      @visible="visible"
      :passVisible="brandVisible"
      :title="addBrandTitle"
      @submitForm="submitForm"
      :defaultArray="defaultArray"
    ></AddNewDialog>
    <!-- 添加用户 -->
    <UserRoleDialog
      @visible="visible"
      :passVisible="roleVisible"
      :title="addRoleTitle"
      @submitFormRole="submitFormRole"
      :roleArray="roleArray"
    ></UserRoleDialog>
  </div>
</template>

<script>
import TableTem from "./components/TableTem.vue";
import { tableCols } from "@/conf/User.js";
import AddNewDialog from "./components/AddNewDialog.vue";
import UserRoleDialog from "./components/UserRoleDialog.vue";
import {
  userList,
  updateUserState,
  brandUpdate,
  brandSearch,
  userRoleUpdate,
  roleSearch,
} from "@/common/js/http/version3Api.js";
import qs from "qs";

export default {
  name: "User",
  components: {
    TableTem,
    // 添加关联品牌
    AddNewDialog,
    // 添加角色
    UserRoleDialog,
  },
  data() {
    return {
      // 添加关联品牌
      brandVisible: false,
      addBrandTitle: "",
      // 添加角色
      roleVisible: false,
      addRoleTitle: "",
      tableData: [],
      tableCols,
      pagination: {},
      options: [
        {
          value: "1",
          label: "On",
        },
        {
          value: "0",
          label: "Off",
        },
        {
          value: "",
          label: "All",
        },
      ],
      selectValue: "",
      inputValue: "",
      userId: "",
      status: "",
      delStatus: "",
      companyIds: [],
      roleIds: [],
      id: "",
      defaultArray: [],
      roleArray: [],
      allCompanyIds: [],
    };
  },
  created() {
    this.getUserList();
  },
  methods: {
    //添加用户角色关联
    submitFormRole(roleIds) {
      this.roleIds = roleIds;
      this.userRoleUpdate();
    },
    //添加用户品牌关联
    submitForm(companyIds, allCompanyIds) {
      this.companyIds = companyIds;
      this.allCompanyIds = allCompanyIds;
      this.userBrandUpdate();
    },
    //点击开关更新状态
    switchVal2(row) {
      this.userId = row.id;
      this.delStatus = row.delStatus;
      this.status = row.status;
      this.updateUserstate();
    },
    select(row) {},
    // 搜索数据
    searchData() {
      this.getUserList();
    },
    deleteRow(index, rows) {},
    querySwitchVal(val) {},
    scopeData(rowData) {},
    visible(val) {
      this.brandVisible = this.roleVisible = val;
    },
    // 获取 表格传递的数据
    passRowData(rowData) {
      if (rowData.button == "delete") {
        this.userId = rowData.rowData.id;
        this.delStatus = 1;
        this.$confirm("此操作将永久删除该用户, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let data = {
              userId: this.userId,
              status: this.status,
              delStatus: this.delStatus,
              brandToken: localStorage.getItem("brand-token"),
            };
            updateUserState(qs.stringify(data)).then((res) => {
              if (res.code == 200) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.getUserList();
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else if (rowData.button == "addBrand") {
        this.id = rowData.rowData.id;
        this.searchBrand();
      } else {
        this.id = rowData.rowData.id;

        this.searchRole();
      }
      let buttonType = rowData.button;
      switch (buttonType) {
        case "addBrand":
          // 添加关联品牌
          this.brandVisible = true;
          this.addBrandTitle = "Add a related brand";
          break;
        case "addRole":
          // 添加角色
          this.roleVisible = true;
          this.addRoleTitle = "Add Role";
          break;
      }
    },
    //更新状态
    updateUserstate() {
      let data = {
        userId: this.userId,
        status: this.status,
        delStatus: this.delStatus,
        brandToken: localStorage.getItem("brand-token"),
      };
      updateUserState(qs.stringify(data)).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: res.message,
            type: "success",
          });
          this.getUserList();
        }
      });
    },
    //用户品牌关联更新
    userBrandUpdate() {
      brandUpdate({
        id: this.id,
        companyIds: this.companyIds,
        allCompanyIds: this.allCompanyIds,
      }).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: res.message,
            type: "success",
          });
        }
      });
    },
    //用户角色关联更新
    userRoleUpdate() {
      userRoleUpdate({ id: this.id, roleIds: this.roleIds }).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: res.message,
            type: "success",
          });
        }
      });
    },
    //用户关联品牌查询
    searchBrand() {
      brandSearch({ userId: this.id }).then((res) => {
        this.defaultArray = res.result;
      });
    },
    //用户关联角色查询
    searchRole() {
      roleSearch({ userId: this.id }).then((res) => {
        this.roleArray = res.result;
      });
    },
    handleCurrentChange(val) {
      this.pagination.pageNum = val;
      this.getUserList();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
    },
    //获取用户信息列表
    getUserList() {
      let data = {
        status: this.selectValue,
        userName: this.inputValue,
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.pageNum,
      };
      userList(data).then((res) => {
        this.tableData = res.result.list;
        this.pagination.pageNum = res.result.pageNum;
        this.pagination.pageSize = res.result.pageSize;
        this.pagination.total = res.result.total;
      });
    },
  },
  watch: {
    companyIds: {
      handler(val) {
        this.companyIds = val;
      },
      deep: true,
    },
    roleIds: {
      handler(val) {
        this.roleIds = val;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.search_data > div {
  display: inline-block;
  margin-right: 15px;
  vertical-align: middle;
}

.search_data >>> .el-input__inner,
.search_data >>> .el-input__icon {
  height: 32px;
  line-height: 32px;
}

.search_data .item_submit {
  cursor: pointer;
  width: 74px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  font-size: 14px;
  color: #0078ff;
  border-radius: 2px;
  border: 1px solid #0078ff;
}

.user_management {
  padding: 10px;
}
</style>